import React, { createContext, useState, useContext, useEffect } from "react";

const OffcanvasContext = createContext();

export const OffcanvasProvider = ({ children }) => {
  const [isAnyOffcanvasOpen, setIsAnyOffcanvasOpen] = useState(false);

  // useEffect(() => {
  //   const handleEscapeKey = (event) => {
  //     console.log('Escape key listener: event triggered for key:', event.key);
  //     if (event.key === "Escape") {
  //       console.log('Escape key pressed. Attempting to close Bootstrap offcanvas elements.');

  //       const openOffcanvasElements = document.querySelectorAll('.offcanvas.show');
  //       console.log(`Found ${openOffcanvasElements.length} elements with class .offcanvas.show.`);

  //       openOffcanvasElements.forEach(offcanvasEl => {
  //         console.log('Processing offcanvas element:', offcanvasEl);
  //         if (window.bootstrap && window.bootstrap.Offcanvas) {
  //           let offcanvasInstance = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
  //           if (offcanvasInstance) {
  //             console.log('Found Bootstrap Offcanvas instance. Calling hide().');
  //             offcanvasInstance.hide();
  //           } else {
  //             console.log('No existing instance found. Creating new and calling hide().');
  //             // This might happen if the offcanvas was opened without a JS instance being properly stored.
  //             new window.bootstrap.Offcanvas(offcanvasEl).hide();
  //           }
  //         } else {
  //           console.log('window.bootstrap or window.bootstrap.Offcanvas is not available. Manually removing \'show\' class.');
  //           offcanvasEl.classList.remove('show'); // Fallback
  //         }
  //       });

  //       // The setTimeout handles cleanup after Bootstrap's animation completes
  //       setTimeout(() => {
  //         console.log('Animation delay finished. Performing final cleanup.');
  //         // Remove any lingering backdrops (Bootstrap's hide() should remove its own, but this is a safeguard)
  //         document.querySelectorAll('.offcanvas-backdrop').forEach(backdrop => {
  //           console.log('Removing backdrop from DOM:', backdrop);
  //           backdrop.remove();
  //         });

  //         document.body.style.overflow = 'auto';
  //         console.log('Body overflow set to:', document.body.style.overflow);
  //         document.body.classList.remove('offcanvas-open');
  //         console.log('Removed offcanvas-open from body. Current body classes:', document.body.classList.value);
  //         document.body.classList.remove('modal-open');
  //         console.log('Removed modal-open from body. Current body classes:', document.body.classList.value);

  //         setIsAnyOffcanvasOpen(false); // Update context state last
  //         console.log('isAnyOffcanvasOpen state set to false after cleanup.');
  //       }, 300); // 300ms matches Bootstrap's default transition duration
  //     }
  //   };

  //   document.addEventListener("keydown", handleEscapeKey);

  //   // Manage body overflow based on isAnyOffcanvasOpen state, primarily for when offcanvas opens
  //   if (isAnyOffcanvasOpen) {
  //     document.body.style.overflow = 'hidden';
  //     console.log('Body overflow set to hidden due to isAnyOffcanvasOpen state.');
  //   } else {
  //     document.body.style.overflow = 'auto';
  //     console.log('Body overflow set to auto due to isAnyOffcanvasOpen state.');
  //     const backdrop = document.querySelector('.offcanvas-backdrop');
  //     if (backdrop) {
  //       console.log('Removing backdrop based on isAnyOffcanvasOpen state (direct removal for consistency if not escaped).', backdrop);
  //       backdrop.remove();
  //     }
  //   }

  //   return () => {
  //     console.log('Removing keydown event listener.');
  //     document.removeEventListener("keydown", handleEscapeKey);
  //   };
  // }, [isAnyOffcanvasOpen]);

  return (
    <OffcanvasContext.Provider value={{ isAnyOffcanvasOpen }}>
      {children}
    </OffcanvasContext.Provider>
  );
};

export const useOffcanvas = () => useContext(OffcanvasContext);
